import { Article } from 't2-graphql-types';
import { TCloudinaryImageShape } from '../CloudinaryResponsiveImage/types';

export enum BlockType {
  Paragraph = 'paragraph',
  Header = 'header',
  Quote = 'quote',
  Code = 'code',
  Table = 'table',
  List = 'list',
  Image = 'image',
}

type TAlignment = 'left' | 'center' | 'right';
type TListStyle = 'ordered' | 'unordered';

export type TBlock<T> = {
  type: BlockType;
  data: T;
  id: string;
};

export type TCodeBlockData = {
  code: string;
  theme?: string;
  language?: string;
};
export type THeaderBlockData = {
  text: string;
  level?: 1 | 2 | 3 | 4 | 5 | 6;
  alignment: TAlignment;
};
type TListItem = {
  content: string;
  items: TListItem[];
};
export type TListBlockData = {
  items: TListItem[];
  style: TListStyle;
};
export type TParagraphBlockData = {
  text: string;
  alignment: TAlignment;
};
export type TQuoteBlockData = {
  text: string;
  caption: string;
  alignment: TAlignment;
};
export type TTableBlockData = {
  content: string[][];
  withHeadings: boolean;
};

export type TCloudinaryImageBlockData = {
  file: TCloudinaryImageShape;
  caption: string;
};

export type TArticleBodyBlock =
  | TBlock<TCodeBlockData>
  | TBlock<THeaderBlockData>
  | TBlock<TListBlockData>
  | TBlock<TParagraphBlockData>
  | TBlock<TQuoteBlockData>
  | TBlock<TTableBlockData>
  | TBlock<TCloudinaryImageBlockData>;

export type TArticleBody = {
  blocks: TArticleBodyBlock[];
  time: number;
  version: string;
};

export type TArticleBodyRendererProps = {
  articleId: Article['id'];
  body: TArticleBody;
};

export type TMatchMode = 'match-on-start' | 'match-on-end' | 'match-fully' | 'match-anywhere';
